import _, { identity } from "lodash";
import { SerializerExtensions, serializerExtensions } from "../extensions";
import { Serializer } from "../serializer";

export const mapObject = <TValue, TKey extends string = string>(
  valueSerializer: Serializer<TValue>,
  keySerializer?: Serializer<TKey>,
): Serializer<Record<TKey, TValue>> &
  SerializerExtensions<Record<TKey, TValue>> => ({
  serialize: (input) =>
    _(input)
      .mapValues(valueSerializer.serialize)
      .mapKeys((v, key) => (keySerializer?.serialize ?? identity)(key as any))
      .value(),
  deserialize: (raw) =>
    _(raw)
      .mapValues(valueSerializer.deserialize)
      .mapKeys((v, key) => (keySerializer?.deserialize ?? identity)(key))
      .value() as any,
  ...serializerExtensions(),
});
